
import React, { useContext } from "react";
import { LanguageContext } from "../context/LanguageContext"

import Header from "../components/header"
import Footer from "../components/footer"
import Body from "../components/body"

import CompanyInfo from "../components/companyInfo";
import UsersCount from "../components/usersCount";
import MachinesList2 from "../components/machineList2";
import ProdList1 from "../components/prodlist";
import BatchList1 from "../components/batchList";
import BatchList2 from "../components/batchList2";
import BatchListRep from "../components/batchList4";
import BatchTempList1 from "../components/batchTempList1";

const BatchesTempPage = () => {

  const { t } = useContext(LanguageContext); // 👈 Usa el hook para traer traducciones
  const user = JSON.parse(localStorage.getItem("user"));
  const company = JSON.parse(localStorage.getItem("company"));


  return (
    <>


      <div class="body">
        <Header />
        <h2>{t("batchList28")}</h2>

        <div>


          <BatchTempList1 id_c ={company.id_c} />



        </div>

      </div>



    </>
  )
}

export default BatchesTempPage;